import moment from "moment";
import {Moment} from "moment";

export default class MyDate {
    private readonly date: Moment;

    /**
     *
     * @param value - If number type, pass milliseconds
     */
    constructor(value: string | number | Date = Date.now()) {
        this.date = moment(value)
    }

    public getMoment(): Moment{
        return this.date;
    }

    public toMillis(): number{
        return this.date.valueOf();
    }

    public addDays(numberOfDays: number): MyDate {
        const newDate = this.date.clone();
        newDate.add(numberOfDays, 'days');
        return new MyDate(newDate.toDate());
    }

    public addSeconds(numberOfSeconds: number): MyDate {
        const newDate = moment(this.date.toDate());
        newDate.add(numberOfSeconds, 'seconds');
        return new MyDate(newDate.toDate());
    }

    public addMinutes(numberOfMinutes: number): MyDate {
        const newDate = moment(this.date.toDate());
        newDate.add(numberOfMinutes, 'minutes');
        return new MyDate(newDate.toDate());
    }

    public getDay(): number{
        return parseInt(this.date.format("DD"))
    }

    public getHour(): number{
        return parseInt(this.date.format("H"))
    }

    public getMonth(): number{
        return this.date.month() + 1;
    }

    public getMonthShortName(): string{
        return this.date.format("MMM");
    }

    public getMonthFullName(): string{
        return this.date.format("MMMM");
    }

    public getYear(): number{
        return this.date.year();
    }

    public getYear2Digits(): string{
        return this.date.format("YY");
    }

    public addHours(numberOfHours: number): MyDate {
        const newDate = moment(this.date.toDate());
        newDate.add(numberOfHours, 'hours');
        return new MyDate(newDate.toDate());
    }

    public addMonths(numberOfMonths: number): MyDate {
        const newDate = moment(this.date.toDate());
        newDate.add(numberOfMonths, 'months');
        return new MyDate(newDate.toDate());
    }

    public set(options: {hour?: number, minute?: number, second?: number, millisecond?: number})
    {
        return new MyDate(this.date.clone().set(options).format("YYYY-MM-DD HH:mm:ss.SSS"));
    }

    public addYears(numberOfYears: number): MyDate {
        const newDate = moment(this.date.toDate());
        newDate.add(numberOfYears, 'years');
        return new MyDate(newDate.toDate());
    }

    public getStartOfDay(): MyDate{
        const newDate: Moment = moment(this.date.toDate());
        return new MyDate(newDate.startOf("day").toDate());
    }

    public compareTo(value: string | number | Date | MyDate): number {
        let otherDate: MyDate;
        if (value instanceof MyDate)
            otherDate = value;
        else
            otherDate = new MyDate(value);
        if (this.date.isBefore(otherDate.getMoment()))
            return -1;
        else if (this.date.isSame(otherDate.getMoment()))
            return 0;
        return 1;
    }

    public toString(format: string): string {
        return this.date.format(format);
    }

    public toDateString() {
        return this.date.format("YYYY-MM-DD");
    }

    public toLongDateTimeString() {
        return this.date.format("MMMM Do YYYY, h:mm:ss a");
    }

    /**
     * Converts the time to UTC before returning it as string
     */
    public toMysqlDateTime(){
        return this.date.clone().utc().format("YYYY-MM-DD HH:mm:ss.SSS");
    }

    public toDateTime(){
        return this.date.clone().format("YYYY-MM-DD HH:mm:ss.SSS");
    }

    public toIsoString(){
        return this.date.clone().format("YYYY-MM-DDTHH:mm:ss.sssZ");
    }

    public toUTC(){
        return new MyDate(this.date.clone().utc().format("YYYY-MM-DD HH:mm:ss.SSS"))
    }

    public static getGMTTimeZone(): string
    {
        const value: number = new Date().getTimezoneOffset();
        let minus: string = "-";
        if (value < 0)
            minus = "+";
        const hours: number = Math.floor(Math.abs(value / 60));
        const minutes: number = Math.abs(value) % 60;
        return `${minus}${hours < 10 ? '0' : ''}${hours}:${minutes < 10 ? '0' : ''}${minutes}`;
    }

}


